import circle_not_closed from '../images/circle_not_closed.svg'
import circle from '../images/circle.svg'
import circle_with_errors from '../images/circle_with_errors.svg'
import circle_not_closed_active from '../images/circle_not_closed_active.svg'
import circle_not_closed_previous from '../images/circle_not_closed_previous.svg'
import circle_active from '../images/circle_active.svg'
import t from './translate'

function Item ({ number, step, onClick, isLastStep, active, previous, hasErrors, clickable }) {
  
  let _circle
  
  if (isLastStep) {
      _circle = active ? circle_active : circle
  } else {
    if (previous && !active) {
      _circle = circle_not_closed_previous
    } else {
      _circle = active ? circle_not_closed_active : circle_not_closed
    }
  }

  let classes = 'menu-item'

  if(active) {
    classes += ' active'
  } else if (previous && !active) {
    classes += ' previous'
  }

  if(clickable) {
    classes += ' clickable'
  }

  return (<div className={classes} onClick={onClick}>
    <div className="circle">
      <img alt="" src={_circle}/>
      <div className="number">{number}</div>
    </div>
    <div className="text">
      {t('menu.' + step)}
    </div>
  </div>)
}

export default function Menu ({ steps, currentStep, setStep, errors, highestStep }) {
  return <div className="menu">
    {steps.map((step, id) => {
      let hasErrors = step in errors;
      if(id == steps.length - 1) return;
      let props = {
        key: id,
        previous: id <= highestStep,
        active: id === currentStep,
        number: id + 1,
        step: step,
        onClick: () => {},
        isLastStep: id >= steps.length - 1,
        hasErrors: hasErrors
      }

      if(highestStep >= id) {
        props.onClick = () => {setStep(id)}
        props.clickable = true;
      }

      return <Item key={step} {...props} />
    })}
  </div>
}
